import type { ReactNode } from 'react'

import css from './ContactsTable.module.css'

export function SelectedOutput({
	amount,
	areAllSelected,
	children,
	selectAll,
	total,
	unSelectAll
}: {
	amount: number
	areAllSelected: boolean
	children?: ReactNode
	selectAll?: () => void
	total: number
	unSelectAll?: () => void
}) {
	return (
		<th className={css.selectedSummary}>
			<output className={css.total}>{`${amount} of ${total} selected`}</output>

			{areAllSelected ? (
				<button className={css.invisible} onClick={unSelectAll} type='button'>
					Clear
				</button>
			) : (
				<button className={css.invisible} onClick={selectAll} type='button'>
					Select all
				</button>
			)}

			<div className={css.selectedMenu}>{children}</div>
		</th>
	)
}
